import { colorPalette } from "@directv-digital/dds.ui.dtv-theme";
import { CardHeight, IMediaModuleStyleProps } from "./media-module.types";
import FusionTheme from "@directv-digital/fusion.themes.fusion";

const fusionPalette = FusionTheme.fusion.palette;

export const mediaModuleStyles = ({
  backgroundColor,
  textColor,
  cardHeight,
  ctaMobileLayout,
  imageAlignment,
  hasTertiaryCta
}: IMediaModuleStyleProps) => ({
  cardMainContainer: {
    position: "relative",
    flex: {
      md: "0 0 calc(50% - 10px)",
      xs: "0 0 100%"
    }
  },
  cardMainContainer1Up: {
    flex: {
      md: "0 0 100%",
      xs: "0 0 100%"
    }
  },
  bgImageContainer: {
    position: "absolute",
    left: 0,
    top: 0,
    width: "100%",
    height: "100%"
  },
  cardContainer: {
    position: "relative",
    display: "flex",
    height:
      cardHeight === CardHeight.FIXED ?
        {
          md: "500px",
          sm: "460px",
          xs: "351px"
        } :
        "100%",
    overflow: "hidden",
    // For FLEX card height we use space-between so content stretches to fill
    // the vertical space between header and footer areas. For other heights
    // we align content to the top (flex-start) to avoid extra vertical gaps.
    justifyContent: cardHeight === CardHeight.FLEX ?
      "space-between" :
      {
        md: "flex-start",
        xs: "flex-start"
      },
    flexDirection: {
      xs: "column",
      md: "column"
    }
  },
  cardContainer1Up: {
    height: {
      md: "auto",
      sm: "auto",
      xs: "auto"
    },
    justifyContent: {
      md: "flex-start",
      xs: "flex-start"
    },
    flexDirection: {
      xs: "column",
      md: "row"
    }
  },
  cardBackground: {
    background:
      backgroundColor || "linear-gradient(180deg, #EBF3FF 0%, #F5F4F2 100%)"
  },
  cardBackground1Up: {
    background:
      backgroundColor ||
      "radial-gradient(865.55% 156.92% at 100% -11.28%, #F5F7FA 0%, #F5F3F0 100%)"
  },
  contentContainer: {
    textAlign: {
      md: "center",
      xs: "center"
    },
    padding: {
      md: "40px 56px 16px 56px",
      sm: "32px 56px 16px 56px",
      xs: "24px 20px 16px 20px"
    }
  },
  contentContainer1Up: {
    textAlign: {
      md: "left",
      sm: "center",
      xs: "center"
    },
    padding: {
      lg: "40px 0 40px 210px",
      md: "40px 0 40px 120px",
      sm: "40px 32px 16px 32px",
      xs: "32px 20px 8px 20px"
    }
  },
  eyebrow: {
    color: textColor || fusionPalette.neutral_black
  },
  eyebrow1Up: {
    color: textColor || "#000443"
  },
  headline: {
    color: textColor || fusionPalette.neutral_black,
    maxWidth: {
      md: "820px",
      sm: "720px",
      xs: "400px"
    },
    display: "block",
    margin: "0 auto"
  },
  headline1Up: {
    color: textColor || "#000443"
  },
  headlineSpacing: {
    margin: {
      md: "8px auto 0 auto",
      xs: "4px auto 0 auto"
    }
  },
  headlineSpacing1Up: {
    margin: {
      md: "8px auto 0 auto",
      xs: "8px auto 0 auto"
    }
  },
  description: {
    margin: "4px auto 0 auto",
    color: textColor || "#121212",
    maxWidth: {
      md: "820px",
      sm: "720px",
      xs: "400px"
    }
  },
  description1Up: {
    margin: "12px auto 0 auto",
    color: textColor || "#000443"
  },
  emailCaptureContainer: {
    margin: {
      md: "24px 0 0 0",
      xs: "16px 0 0 0"
    },
    display: "flex",
    gap: "12px",
    flexDirection: {
      md: "row",
      sm: "row",
      xs: "column"
    },
    alignItems: {
      sm: "flex-start",
      xs: "center"
    },
    justifyContent: {
      md: "flex-start",
      sm: "center",
      xs: "flex-start"
    },
    '& .MuiTextField-root': {
      width: {
        md: "271px",
        sm: "251px",
        xs: "100%"
      },
      minWidth: {
        md: "271px",
        sm: "251px",
        xs: "100%"
      }
    }
  },
  InputPropsStyles: {
    borderRadius: "124px",
    background: "#FFFFFF4D",
    padding: "0px 16px !important",
    height: "36px"
  },
  InputPropsStylesMedium: {
    height: "48px"
  },
  InputPropsStylesLarge: {
    height: "56px"
  },
  inputPropsStyles: {
    padding: "0px"
  },
  inputLabelRootStyles: {
    marginLeft: "4px !important",
    color: `${fusionPalette.neutral700}} !important`,
    typography: "body3",
    top: "-12px"
  },
  inputLabelRootStylesMedium: {
    top: "-8px"
  },
  inputLabelRootStylesLarge: {
    top: "-2px"
  },
  inputLabelShrinkStyles: {
    top: "2px"
  },
  ctaContainer: {
    // Generated by Copilot- Start - 2026-02-26 13:48:01
    display: ctaMobileLayout === "stacked" ? {
      md: "flex",
      xs: "inline-flex"
    } : "flex",
    // Generated by Copilot- End - 2026-02-26 13:48:01
    // Generated by Copilot- Start - 2026-02-27 18:54:27
    gap: hasTertiaryCta ?
      {
        md: "48px",
        sm: "24px",
        xs: "22px"
      } :
      {
        sm: "16px",
        xs: "8px"
      },
    // Generated by Copilot- End - 2026-02-27 18:54:27
    justifyContent: {
      md: "center",
      xs: "center"
    },
    // Generated by Copilot- Start - 2026-02-26 13:48:01
    ...(ctaMobileLayout && {
      flexDirection: {
        md: "row",
        sm: "row",
        xs: ctaMobileLayout === "row" ? "row" : "column"
      },
      flexWrap: ctaMobileLayout === "row" ? "nowrap" : "wrap",
      alignItems: {
        md: "center",
        sm: "center",
        xs: ctaMobileLayout === "row" ? "center" : "stretch"
      }
    }),
    // Generated by Copilot- End - 2026-02-26 13:48:01
    margin: {
      md: "20px 0 0 0",
      sm: "20px 0 0 0",
      xs: "16px 0 0 0"
    }
  },

  ctaContainer1Up: {
    flexWrap: "wrap",
    justifyContent: {
      md: "flex-start",
      xs: "center"
    },
    // Generated by Copilot- Start - 2026-02-26 13:48:01
    display: ctaMobileLayout === "stacked" ? {
      md: "flex",
      xs: "inline-flex"
    } : "flex",
    ...(ctaMobileLayout && {
      flexDirection: {
        md: "row",
        sm: "row",
        xs: ctaMobileLayout === "row" ? "row" : "column"
      },
      alignItems: {
        md: "center",
        sm: "center",
        xs: ctaMobileLayout === "row" ? "flex-start" : "stretch"
      }

    }),
    // Generated by Copilot- End - 2026-02-26 13:48:01
    // Generated by Copilot- Start - 2026-02-27 18:54:27
    gap: hasTertiaryCta ?
      {
        md: "48px",
        sm: "24px",
        xs: "24px"
      } :
      {
        md: "12px",
        sm: "12px",
        xs: "12px"
      },
    // Generated by Copilot- End - 2026-02-27 18:54:27
    margin: {
      md: "24px 0 0 0",
      sm: "24px 0 0 0",
      xs: "14px 0 0 0"
    }
  },

  button: {
    height: "36px",
    paddingTop: "0px",
    paddingBottom: "0px",
    typography: "body3medium"
  },
  buttonMedium: {
    height: "48px"
  },
  buttonLarge: {
    height: "56px"
  },
  submitCta: (color, backgroundColor) => ({
    width: {
      md: "auto",
      sm: "auto",
      xs: "100%"
    },
    backgroundColor: backgroundColor || colorPalette.newBlue[600],
    // Default neutral_white (#FFFFFF), not white (#FEFEFE): on newBlue[600] (#006DFF)
    // pure white is 4.53:1 (WCAG AA pass) while #FEFEFE is 4.49:1 and fails color-contrast.
    color: `${color || colorPalette.neutral_white.main} !important`,
    ...(color && {
      "&:before": {
        border: `2px solid ${color}`
      }
    })
  }),
  cta: (color, backgroundColor) => ({
    backgroundColor: backgroundColor || colorPalette.newBlue[600],
    // Same contrast rationale as submitCta above.
    color: `${color || colorPalette.neutral_white.main} !important`,
    ...(color && {
      "&:before": {
        border: `2px solid ${color}`
      }
    })
  }
  ),
  secondaryCta: (color, backgroundColor) => ({
    color: `${color || "#0062E3"} !important`,
    "&:before": {
      border: `2px solid ${color || "#0062E3"}`
    },
    ...(backgroundColor && {
      backgroundColor
    })
  }),
  // Generated by Copilot- Start - 2026-02-25 22:29:48
  tertiaryCta: (color, backgroundColor) => ({
    color: `${color || "#FFFFFF"} !important`,
    textDecoration: "none",
    background: "transparent",
    border: "none",
    padding: "0px",
    minWidth: "unset",
    height: "auto !important",
    lineHeight: "normal",
    display: "inline-flex",
    alignItems: "center",
    "& .MuiButton-endIcon": {
      marginLeft: "4px",
      "& .MuiAvatar-root": {
        height: "16px",
        width: "16px"
      }
    },
    "&:before": {
      border: "none"
    },
    "&:hover": {
      textDecoration: "underline",
      background: "transparent"
    },
    ...(backgroundColor && {
      backgroundColor
    })
  }),
  // Generated by Copilot- End - 2026-02-25 22:29:48
  legalText: {
    fontFamily: "roboto-regular",
    fontSize: "12px !important",
    margin: "16px 0 0 0",
    color: "#555555"
  },
  imageMainContainer: {
    width: "100%",
    display: "flex",
    overflow: "hidden",
    justifyContent: {
      md: "center",
      xs: "center"
    },
    // Generated by Copilot- Start - 2026-02-25 22:29:48
    ...(imageAlignment && {
      alignItems: imageAlignment === "bottom" ? "flex-end" : "flex-start",
      marginTop: imageAlignment === "bottom" ? "auto" : "0"
    }),
    // Generated by Copilot- End - 2026-02-25 22:29:48
    padding: {
      md: "0 0 0 0",
      sm: "0 22px 0 22px",
      xs: "0 0 0 0"
    }
  },
  imageMainContainer1Up: {
    justifyContent: {
      md: "end",
      xs: "center"
    },
    padding: {
      md: "40px 0 40px 0",
      sm: "0px 32px 10px 32px",
      xs: "8px 0px 10px 0px"
    },
    flexBasis: "min-content",
    flexGrow: "1",
    flexShrink: "0"
  },
  imageContainer: {
    height: {
      md: "auto",
      sm: "auto",
      xs: "auto"
    },
    width: {
      md: "100%",
      sm: "100%",
      xs: "100%"
    }
  },

  imageContainer1Up: {
    height: {
      md: "auto",
      sm: "auto",
      xs: "auto"
    },
    width: {
      md: "595px",
      sm: "100%",
      xs: "100%"
    }
  },
  image: {
    width: "100%",
    height: "100%",
    objectFit: "cover" as any,
    objectPosition: "top",
    maxWidth: "710px",
    display: "block",
    margin: "0 auto"
  },
  image1Up: {
    width: "100%",
    height: "auto",
    objectFit: "unset" as any,
    maxWidth: "unset",
    objectPosition: "unset",
    margin: "unset"
  }
});
